import styled from "styled-components";

const LineBreakWrapper = styled.div`
    border-bottom: 2px solid black;
`;

export default LineBreakWrapper;
